import {INITIAL_SERVER_DATA, SET_URL_PARAMS} from "../actionTypes";

export function initServerStaticData() {
    return {
        type: INITIAL_SERVER_DATA
    }
}

export function setUrlParams(params) {
    return {
        type: SET_URL_PARAMS,
        params
    }
}


// WEBPACK FOOTER //
// ./src/actions/common/staticDataActions.js